import { MAX_IMAGE_POST } from '../../config'
import { Screenshot } from './helpers'

import { PostBoxPhotosLabel } from './PostBoxPhotosLabel'

type Props = {
  screenshots: Screenshot[]
  hasGifImage: boolean
  onChangeImageUpload: (i: number) => PostBoxPhotosLabel['onChangeImageUpload']
  onDeleteImageUpload: (i: number) => PostBoxPhotosLabel['onDeleteImageUpload']
}

const PostBoxPhotos = ({
  screenshots,
  hasGifImage,
  onChangeImageUpload,
  onDeleteImageUpload,
}: Props) => {
  return (
    <div className="PostBox__body__photos">
      <div className="PostBox__body__photos__labels">
        {Array.from(Array(hasGifImage ? 1 : MAX_IMAGE_POST)).map((_, i) => (
          <PostBoxPhotosLabel
            key={i}
            file={screenshots[i]?.file}
            disabled={i > screenshots.length}
            onChangeImageUpload={onChangeImageUpload(i)}
            onDeleteImageUpload={onDeleteImageUpload(i)}
            accept={
              screenshots.length
                ? '.jpg, .jpeg, .png'
                : '.jpg, .jpeg, .png, .gif'
            }
          />
        ))}
      </div>
    </div>
  )
}

export default PostBoxPhotos
